"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableNeoDark = exports.tableNeoLight = exports.tableNovoDark = exports.tableNovo = exports.table = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const table = {
    tableFontFamily: font_const_1.default.family,
    tableBorderColor: color_const_1.default.cloudyBlue300,
    fontVariantNumeric: 'unset',
    // Hover & Selected
    tableRowHoverColor: color_const_1.default.pickledBluewood800,
    tableRowHoverBackgroundColor: color_const_1.default.cloudyBlue100,
    tableRowSelectedBackgroundColor: color_const_1.default.cloudyBlue300,
    zebraRowBackgroundColor: color_const_1.default.cloudyBlue100,
    // Cell/Row
    tableCellFontSize: font_const_1.default.sizeSm,
    tableCellLineHeight: font_const_1.default.lineHeightSm,
    tableCellPadding: `${spacing_const_1.default.md} ${spacing_const_1.default.xs}`,
    tableCellColor: color_const_1.default.pickledBluewood800,
    tableCellBackgroundColor: 'unset',
    tableCellFontWeight: 'unset',
    tableCellLetterSpacing: 'unset',
    tableCellFontFamily: 'unset',
    // Header
    tableCellHeadFontSize: font_const_1.default.sizeSm,
    tableCellHeadLineHeight: font_const_1.default.lineHeightSm,
    tableCellHeadFontWeight: font_const_1.default.weightAttention,
    tableCellHeadColor: color_const_1.default.steel700,
    tableCellHeadBackgroundColor: 'unset',
    tableCellHeadLetterSpacing: 'unset',
    tableCellHeadFontFamily: 'unset',
};
exports.table = table;
const tableCellTypography = {
    tableCellFontSize: light.body01.fontSize,
    tableCellLineHeight: light.body01.lineHeight,
    tableCellFontWeight: light.body01.fontWeight,
    tableCellLetterSpacing: light.body01.letterSpacing,
    tableCellFontFamily: light.body01.fontFamily,
};
const tableCellHeadTypography = {
    tableCellHeadFontSize: light.bodyBold01.fontSize,
    tableCellHeadLineHeight: light.bodyBold01.lineHeight,
    tableCellHeadFontWeight: light.bodyBold01.fontWeight,
    tableCellHeadLetterSpacing: light.bodyBold01.letterSpacing,
    tableCellHeadFontFamily: light.bodyBold01.fontFamily,
};
const tableNovo = {
    ...table,
    tableFontFamily: light.body01.fontFamily,
    fontVariantNumeric: 'tabular-nums',
    // Cell/Row
    ...tableCellTypography,
    tableCellColor: light.textColor05,
    tableCellBackgroundColor: 'unset',
    // Header
    ...tableCellHeadTypography,
    tableCellHeadColor: light.textColor01,
    tableCellHeadBackgroundColor: 'unset',
    tableBorderColor: light.ui02,
    // Hover & Selected
    tableRowHoverColor: light.textColor01,
    tableRowHoverBackgroundColor: light.ui05,
    tableRowSelectedBackgroundColor: light.active08,
    zebraRowBackgroundColor: light.ui05,
    tableCellPadding: `${light.spacing04} ${light.spacing05}`,
};
exports.tableNovo = tableNovo;
const tableNovoDark = {
    ...tableNovo,
    // Cell/Row
    tableCellColor: dark.textColor05,
    // Header
    tableCellHeadColor: dark.textColor01,
    tableBorderColor: dark.ui02,
    // Hover & Selected
    tableRowHoverColor: dark.textColor01,
    tableRowHoverBackgroundColor: dark.ui05,
    tableRowSelectedBackgroundColor: dark.active08,
    zebraRowBackgroundColor: dark.ui05,
};
exports.tableNovoDark = tableNovoDark;
const tableNeoLight = {
    ...tableNovo,
    tableCellColor: neoLight.textColor05,
    tableCellHeadColor: neoLight.textColor01,
    tableBorderColor: neoLight.ui02,
    tableRowHoverColor: neoLight.textColor01,
    tableRowHoverBackgroundColor: neoLight.ui05,
    tableRowSelectedBackgroundColor: neoLight.active08,
    zebraRowBackgroundColor: neoLight.ui05,
};
exports.tableNeoLight = tableNeoLight;
const tableNeoDark = {
    ...tableNovoDark,
    tableCellColor: neoDark.textColor05,
    tableCellHeadColor: neoDark.textColor01,
    tableBorderColor: neoDark.ui02,
    tableRowHoverColor: neoDark.textColor01,
    tableRowHoverBackgroundColor: neoDark.ui05,
    tableRowSelectedBackgroundColor: neoDark.active08,
    zebraRowBackgroundColor: neoDark.ui05,
};
exports.tableNeoDark = tableNeoDark;
